import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import axios from 'axios';
import fr from './locales/fr.json';
import en from './locales/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en }
    },
    fallbackLng: 'fr',
    showSupportNotice: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    }
  });

// The API answers user-facing messages in the UI language (backend/i18n_messages.py).
// Guarded: tests that mock axios have no `defaults`.
const setApiLanguage = (lng) => {
  if (axios.defaults?.headers?.common) axios.defaults.headers.common['Accept-Language'] = lng || 'fr';
};
setApiLanguage(i18n.language);

// Update html lang attribute (and the API language) on language change
i18n.on('languageChanged', (lng) => {
  document.documentElement.setAttribute('lang', lng);
  setApiLanguage(lng);
});

export default i18n;
